<template>
    <div class="analytic-filter-component">
        <div class="range-select">
            <div class="dropdown-range">
                <h6>{{translate('groupBy')}}:</h6>
                <b-dropdown
                        :text="translate(showReportByChosen.tag)"
                        no-caret>
                    <b-dropdown-item v-for="item in showReportBy"
                                     v-on:click="showReportByFilter(item.tag)"
                                     :key="item.tag">
                        <span>{{translate(item.tag)}}</span>
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <div class="range-select">
            <div class="dropdown-range">
                <h6>{{translate('own_selectRange')}}:</h6>
                <b-dropdown :text="this.translate(analyticTimeFilter.name)" no-caret>
                    <b-dropdown-item v-on:click="setActive('day')">
                        <span>{{translate('own_today')}}</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-on:click="setActive('week')">
                        <span>{{translate('own_last7days')}}</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-on:click="setActive('all')">
                        <span>{{this.translate('own_allTime')}}</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-on:click="setActive('custom')">
                        <span>{{this.translate('own_custom')}}...</span>
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <div class="dropdown-range" v-if="isVisibleDropdown">
                <h6>{{translate('site')}}:</h6>
                <b-dropdown 
                        :text="analyticSiteFilter.tag === 'all' ? translate(analyticSiteFilter.tag) : analyticSiteFilter.tag"
                        no-caret>
                    <b-dropdown-item v-on:click="chooseSite({tag:'all', uid: ''})">
                        <span>{{translate('all')}}</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-for="(item, index) in siteListDropdown" :key="index"
                                     v-on:click="chooseSite({tag: item.tag, uid: item.uid})"
                                     :class="{}">
                        <span>{{item.tag}}</span>
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <div class="calendar-inline mr-10" v-if="analyticTimeFilter.attr == 'custom'">
            <div :class="'input ' + [customDate.date_from ? 'have-data' : ''] + [!showDateFrom ? ' hide-picker' : '']">
                <date-picker
                        name="date"
                        id="datefrom"
                        v-model="dateFromModel"
                        :config="optionsFrom"
                        @dp-hide="doSomethingOnHide"
                        @dp-change="doSomethingOnChangeFrom"
                ></date-picker>
                <label>{{translate('From')}}</label>
                <label @click="showDateFrom = !showDateFrom" class="btn" for="datefrom">
                    <img src="@/assets/icons/ic_calendar-1.svg">
                </label>
            </div>
        </div>
        <div class="calendar-inline" v-if="analyticTimeFilter.attr == 'custom'">
            <div :class="'input ' + [customDate.date_to ? 'have-data' : ''] + [!showDateTo ? ' hide-picker' : '']">
                <date-picker
                        name="date"
                        id="dateto"
                        v-model="dateToModel"
                        :config="optionsTo"
                        @dp-hide="doSomethingOnHide"
                        @dp-change="doSomethingOnChangeTo"
                ></date-picker>
                <label>{{translate('To')}}</label>
                <label @click="showDateTo = !showDateTo" class="btn" for="dateto">
                    <img src="@/assets/icons/ic_calendar-1.svg">
                </label>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapMutations, mapState} from "vuex";
    import datePicker from "vue-bootstrap-datetimepicker";
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.min.css';
    let tooltipTranslate = {
        today: "Go to today",
        clear: "Clear selection",
        close: "Close the picker",
        selectMonth: "Select Month1",
        prevMonth: "Previous Month",
        nextMonth: "Next Month",
        selectYear: "Select Year",
        prevYear: "Previous Year",
        nextYear: "Next Year",
        selectDecade: "Select Decade",
        prevDecade: "Previous Decade",
        nextDecade: "Next Decade",
        prevCentury: "Previous Century",
        nextCentury: "Next Century",
        pickHour: "Pick Hour",
        incrementHour: "Increment Hour",
        decrementHour: "Decrement Hour",
        pickMinute: "Pick Minute",
        incrementMinute: "Increment Minute",
        decrementMinute: "Decrement Minute",
        pickSecond: "Pick Second",
        incrementSecond: "Increment Second",
        decrementSecond: "Decrement Second",
        togglePeriod: "Toggle Period",
        selectTime: "Select Time"
    }

    export default {
        name: 'analyticFilter',

        data(){
            return {
                dateFromModel: undefined,
                dateToModel: undefined,
                showDateFrom: false,
                showDateTo: false,
                isActive: false,
                showReportBy: [
                    {
                        tag: 'by_questions'
                    },
                    {
                        tag: 'by_sites'
                    },
                    {
                        tag: 'by_locations'
                    }
                ],
                optionsFrom: {
                    format: 'MM/DD/YYYY H:mm', // https://momentjs.com/docs/#/displaying/
                    useCurrent: false,
                    minDate: false,
                    maxDate: false,
                    tooltips: tooltipTranslate,
                    // locale: 'ua',
                    keyBinds: false
                },
                optionsTo: {
                    format: 'MM/DD/YYYY H:mm', // https://momentjs.com/docs/#/displaying/
                    useCurrent: false,
                    minDate: false,
                    maxDate: false,
                    tooltips: tooltipTranslate,
                    keyBinds: false
                },
            }
        },

        components: {
            datePicker
        },

        props: ['isVisibleDropdown', 'dateFrom', 'dateTo'],

        mounted() {
            this.dateFromModel = this.dateFrom;
            this.dateToModel = this.dateTo;
        },

        computed: {
            ...mapState({
                customDate: state => state.owner.customDate,
                analyticTimeFilter: state => state.owner.analyticTimeFilter,
                analyticSiteFilter: state => state.owner.analyticSiteFilter,
                analyticSiteFilterDefault: state => state.owner.analyticSiteFilterDefault,
                showReportBy: state => state.owner.showReportBy,
                showReportByChosen: state => state.owner.showReportByChosen,
                siteListDropdown: state => state.owner.siteListDropdown,
            }),

        },

        watch: {
            dateFromModel(val) {
                this.setCustomDate({
                    date_from: val
                })
            },
            dateToModel(val) {
                this.setCustomDate({
                    date_to: val
                })
            }
        },

        methods: {

            ...mapMutations({
                setAnalyticFilter: 'owner/setAnalyticFilter',
                setShowReportValue: 'owner/showReportByFilter',
                setCustomDate: 'owner/setCustomDate'
            }),

            chooseSite(item) {
                this.setAnalyticFilter({
                    analyticSiteFilter: item
                })
            },

            showReportByFilter(item) {
                this.setShowReportValue(item)
            },

            setActive(menuItem) {
                let oneDay = 86400000;
                let date = new Date();
                let currentHours = date.getHours() * 60 * 60 * 1000;
                let currentMinutes = date.getMinutes() * 60 * 1000;
                let currentSeconds = date.getSeconds() * 1000;
                let todayMidnight = new Date(date.getTime() - currentHours - currentMinutes - currentSeconds).getTime();
                let lastWeek = new Date(todayMidnight - (oneDay * 7)).getTime();
                switch (menuItem) {
                    case 'day': {
                        this.setAnalyticFilter({
                            analyticTimeFilter: {
                                name: 'own_today',
                                attr: 'day'
                            }
                        })
                        break;
                    }
                    case 'week': {
                        this.setAnalyticFilter({
                            analyticTimeFilter:
                                {
                                    name: 'own_last7days',
                                    attr: 'week'
                                }
                        })
                        break;
                    }
                    case 'month': {
                        this.setAnalyticFilter({
                            analyticTimeFilter: {
                                name: 'own_lastMonth',
                                attr: 'month'
                            }
                        })
                        break;
                    }
                    case 'all': {
                        this.setAnalyticFilter({
                            analyticTimeFilter: {
                                name: 'own_allTime',
                                attr: 'all'
                            }
                        })
                        break;
                    }
                    case 'custom': {
                        this.setAnalyticFilter({
                            analyticTimeFilter: {
                                name: 'own_custom',
                                attr: 'custom'
                            }
                        })
                        if (this.customDate.date_from == undefined) {
                            this.setCustomDate({
                                date_from: new Date(lastWeek)
                            })
                            this.dateFromModel = new Date(lastWeek)
                        }
                        if (this.customDate.date_to == undefined) {
                            this.setCustomDate({
                                date_to: new Date(todayMidnight)
                            })
                            this.dateToModel = new Date(todayMidnight)
                        }
                        break;
                    }
                }

            },

            doSomethingOnHide() {
                this.showDateFrom = false;
                this.showDateTo = false;
            },

            doSomethingOnChangeFrom() {
                if (this.customDate.date_from) {
                    this.optionsTo.minDate = new Date(new Date(this.customDate.date_from).getTime())
                }
            },

            doSomethingOnChangeTo() {
                if (this.customDate.date_to) {
                    this.optionsFrom.maxDate = new Date(new Date(this.customDate.date_to).getTime())
                }
            }

        }
    }

</script>

<style>
    .analytic-filter-component h6 {
        font-size: 13px;
        line-height: 22px;
        margin: 0;
        font-weight: 400;
    }

    .analytic-filter-component .dropdown {
        width: 100%;
    }
    .analytic-filter-component .dropdown:before {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 1;
        content: " ";
        background: #3F405C;
        width: 100%;
        height: 1px;
    }

    .analytic-filter-component .dropdown:after {
        content: '';
        height: 7px;
        width: 7px;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        right: 10px;
        top: 10px;
        position: absolute;
        border-bottom: 2px solid black;
        border-right: 2px solid black;
    }

    .analytic-filter-component .dropdown-range {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 5px 0px 15px;
        border-radius: 4px;
    }

    .analytic-filter-component .dropdown button:focus {
        box-shadow: none !important;
    }
    .analytic-filter-component .dropdown button.btn-secondary {
        background: none !important;
        border: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: #2F2F2F;
        font-weight: 500;
        position: relative;
        padding: 5px 50px 5px 0;
        margin-left: 0;
        font-size: 14px;
    }

    .analytic-filter-component .dropdown-menu {
        width: 100%;
        overflow-y: scroll;
    }

    .analytic-filter-component .dropdown-menu li {
        width: 100%;
        margin: 0;
    }

    .analytic-filter-component .dropdown-menu li a {
        padding: 12px;
    }

    .analytic-filter-component .dropdown-menu li a span {
        font-weight: 600;
        font-size: 14px;
        word-break: break-all;
        white-space: normal;
    }

    .analytic-filter-component .dropdown-item {
        display: block;
        width: 100%;
        padding: 0.25rem 1.5rem;
        clear: both;
        font-weight: 400;
        color: #212529;
        text-align: inherit;
        white-space: nowrap;
        background-color: transparent;
        border: 0;
    }

    .analytic-filter-component .calendar-inline.mr-10 {
        margin-right: 10px;
    }
    .analytic-filter-component .calendar-inline {
        position: relative;
        width: calc(50% - 5px);
        display: inline-flex;
        margin-top: 15px;
        margin-bottom: 25px;
    }

    .analytic-filter-component .calendar-inline .hide-picker .bootstrap-datetimepicker-widget {
        display: none !important;
    }

    .analytic-filter-component .dropdown-menu.bootstrap-datetimepicker-widget {
        font-size: 1em;
        min-width: auto;
        padding: 0.5em 1.5em;
    }

    .analytic-filter-component .calendar-inline .bootstrap-datetimepicker-widget .list-unstyled li {
        width: 100%;
        margin: 0 auto;
    }

    .analytic-filter-component .calendar-inline .input input {
        font-weight: 500;
        font-size: 14px;
        padding: 3px;
        padding-left: 0;
        color: #2F2F2F;
    }

    .analytic-filter-component .calendar-inline .input label ~ label.btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        left: unset;
        cursor: pointer;
        margin: 0;
        padding: 0;
        width: 24px;
        pointer-events: auto;
    }


    .analytic-filter-component .calendar-inline .input label {
        position: absolute;
        top: 10px;
        left: 0;
        pointer-events: none;
        -webkit-transition: .4s cubic-bezier(.25, .8, .25, 1);
        transition: .4s cubic-bezier(.25, .8, .25, 1);
        -webkit-transition-duration: .3s;
        transition-duration: .3s;
    }

    .analytic-filter-component .calendar-inline .input:not(.have-data) input:focus ~ label:not(.btn),
    .analytic-filter-component .calendar-inline .input:not(.have-data) input:active ~ label:not(.btn) {
        font-size: 13px;
        top: -11px;
        line-height: 18px;
    }

    .analytic-filter-component .calendar-inline .input.have-data label:not(.btn) {
        font-size: 13px;
        top: -11px;
        line-height: 18px;
    }

</style>